import SettingsForm from './SettingsForm';

export default SettingsForm;
